import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0893244c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "お知らせ", -1))
const _hoisted_3 = {
  key: 0,
  class: "notice-title"
}
const _hoisted_4 = { class: "font-bold" }

import moment from "moment";
import HorizontalChart from "../components/HorizontalChart.vue";
import PieChart from "../components/PieChart.vue";
import GenderChart from "../components/GenderChart.vue";
import axios from "axios";
import { onMounted, ref, inject } from "vue";
import { get, set } from "@vueuse/core";
import Card from "primevue/card";
import Chip from "primevue/chip";
import ApiRouterConstants from "@/common/constants/api.router.constants";
import ClinicAnalysis from "../components/ClinicAnalysis.vue";
import { useCookies } from "@vueuse/integrations/useCookies";


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const selectedTime = ref(moment().format("YYYY/MM"));
const displayMonth = ref(moment());
const summary = ref({});
const chartData = ref({});
const genderData = ref({});
const visitorData = ref([]);
const clinicId = ref(0);
const labelBackupGender = ["男性", "女性", "その他"];
const labelBackupAge = ["40歳〜", "35〜39歳", "30〜34歳", "25〜29歳", "20〜24歳", "0〜19歳"];

const nextMonth = () => {
  displayMonth.value = displayMonth.value.add(1, "months");
  selectedTime.value = displayMonth.value.format("YYYY/MM");
  handleFetchSumary();
};

const prevMonth = () => {
  displayMonth.value = displayMonth.value.add(-1, "months");
  selectedTime.value = displayMonth.value.format("YYYY/MM");
  handleFetchSumary();
};

const handleFetchSumary = async () => {
  let url = `${ApiRouterConstants.API_ANALYSIS}?clinic_id=${get(clinicId).value}&period=${displayMonth.value.format(
    "MM/YYYY"
  )}`;
  const { get: getCookie } = useCookies();
  const token = getCookie("access_token");
  let res = await axios.get(url, {
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  });

  summary.value = res.data.summary;
  chartData.value = res.data.customers.age[0];
  genderData.value = res.data.customers.gender;
  visitorData.value = res.data.visitors;
};

onMounted(async () => {
  set(clinicId, await inject("clinicId"));
  handleFetchSumary();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_unref(Card), { class: "mb-5 border-round-lg" }, {
      content: _withCtx(() => [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(moment)().format("YYYY年MM月DD日")), 1),
              _createVNode(_unref(Chip), {
                class: "ml-2",
                label: "リリース情報"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})